import { styled } from '@mui/material/styles';
import {
  Box,
  DialogTitle,
  IconButton,
  Typography,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const PREFIX = 'BasicDialogHeader';

const classes = {
  header: `${PREFIX}-header`,
  htop: `${PREFIX}-htop`,
  hbottom: `${PREFIX}-hbottom`,
  title: `${PREFIX}-title`,
  button: `${PREFIX}-button`,
};

const Root = styled(DialogTitle)(({ theme }) => ({
  [`&.${classes.header}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    padding: 0,
  },

  [`& .${classes.htop}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
  },

  [`& .${classes.hbottom}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 144,
    [theme.breakpoints.up('md')]: {
      marginRight: 144,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 32,
    },
    marginBottom: 16,
    marginTop: -12,
    fontFamily: 'Bitter',
  },

  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
  },

  [`& .${classes.button}`]: {
    marginLeft: theme.spacing(1),
  },
}));

interface BasicDialogHeaderProps {
  title: string;
  close: (saved: boolean) => void;
  createFn?: (evt: any) => void;
  importFn?: (evt: any) => void;
}

export default function BasicDialogHeader({
  title,
  close,
  createFn,
  importFn,
}: BasicDialogHeaderProps) {
  const { t } = useTranslation('common');

  const handleClose = () => {
    close(false);
  };

  return (
    <Root className={classes.header}>
      <Box className={classes.htop}>
        <IconButton
          onClick={handleClose}
          aria-label="close"
          data-testid="close"
          size="large">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className={classes.hbottom}>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
        <Box>
          {createFn && (
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={createFn}>
              {t('onboard.add')}
            </Button>
          )}
          {importFn && (
            <>
              <input
                type="file"
                id="importButton"
                name="document"
                hidden
                accept=".csv"
                onChange={importFn}
              />
              <label htmlFor={'importButton'}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  component="div">
                  {t('onboard.import')}
                </Button>
              </label>
            </>
          )}
        </Box>
      </Box>
    </Root>
  );
}
